module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACQAAAAkCAYAAADhAJiYAAAACXBIWXMAABYlAAAWJQFJUiTwAAAANklEQVRYCe3QQQ0AIAwAsYEuNCEGTfgaCQka2KNVcLkAAKCW9mpyjvxZ1ta+Lb3UHgAAiomIA2wBBATxPee0AAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/common/@2x/ic_btn_minus@2x.png
// module id = 309
// module chunks = 0